import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    tag: {
      '& .MuiTypography-subtitle2': {
        display: 'flex',
        alignItems: 'center',
        height: '2.4rem',
        padding: '0 1rem',
        backgroundColor: '#DEE5DA',
        borderRadius: '5px',
        fontSize: '1.1rem',
      },
    },
  }),
)
